import config from 'utils/WebIMConfig'
import websdk from 'easemob-websdk'
import emedia from 'easemob-emedia'
import webrtc from 'easemob-webrtc'

// 初始化IM SDK
var WebIM = {}
WebIM = window.WebIM = websdk
WebIM.config = config
// eslint-disable-next-line new-cap
WebIM.conn = new WebIM.connection({
  appKey: WebIM.config.appkey,
  isHttpDNS: WebIM.config.isHttpDNS,
  isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
  https: WebIM.config.https,
  url: WebIM.config.xmppURL,
  apiUrl: WebIM.config.apiURL,
  isAutoLogin: true,
  heartBeatWait: WebIM.config.heartBeatWait,
  autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
  autoReconnectInterval: WebIM.config.autoReconnectInterval,
  isStropheLog: WebIM.config.isStropheLog,
  delivery: WebIM.config.delivery,
  useOwnUploadFun: true
})
if (!WebIM.conn.apiUrl) {
  WebIM.conn.apiUrl = WebIM.config.apiURL
}

// 注册监听回调
// WebIM.conn.listen({
//   onOpened: function (message) { // 连接成功回调
//     console.log('连接成功', message)
//   },
//   onClosed: function (message) { // 连接关闭回调
//     console.log('连接关闭', message)
//   },
//   onTextMessage: function (message) { // 收到文本消息
//     console.log('收到文本消息', message)
//   },
//   onEmojiMessage: function (message) { // 收到表情消息
//     console.log('收到表情消息', message)
//   },
//   onPictureMessage: function (message) { // 收到图片消息
//     console.log('收到图片消息', message)
//   },
//   onCmdMessage: function (message) { // 收到命令消息
//     console.log('收到命令消息', message)
//   },
//   onAudioMessage: function (message) { // 收到音频消息
//     console.log('收到音频消息', message)
//   },
//   onLocationMessage: function (message) { // 收到位置消息
//     console.log('收到位置消息', message)
//   },
//   onFileMessage: function (message) { // 收到文件消息
//     console.log('收到文件消息', message)
//   },
//   onVideoMessage: function (message) { // 收到视频消息
//     console.log('收到视频消息', message)
//   },
//   onPresence: function (message) {
//     // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
//     console.log('onPresence', message)
//   },
//   onRoster: function (message) { // 处理好友申请
//     console.log('处理好友申请', message)
//   },
//   onInviteMessage: function (message) { // 处理群组邀请
//     console.log('处理群组邀请', message)
//   },
//   onOnline: function () { // 本机网络连接成功
//     console.log('onOnline 网络已连接')
//   },
//   onOffline: function () { // 本机网络掉线
//     console.log('onOffline 网络已断开')
//   },
//   onError: function (message) { // 失败回调
//     console.log('onOffline 网络已断开')
//   },
//   onRecallMessage: message => { // 撤回消息
//     console.log('撤回消息', message)
//   },
//   onBlacklistUpdate: function (list) { // 黑名单变动
//     // console.log('黑名单变动', list)
//   },
//   onReceivedMessage: function (message) { // 收到消息送达服务器回执
//     console.log('onReceivedMessage', message)
//   },

//   onDeliveredMessage: function (message) { // 收到消息送达客户端回执
//     console.log('onDeliveredMessage', message)
//   },

//   onReadMessage: function (message) { // 收到消息已读回执
//     console.log('onReadMessage', message)
//   },

//   onCreateGroup: function (message) { // 创建群组成功回执（需调用createGroupNew）
//     console.log('onCreateGroup', message)
//   },
//   onMutedMessage: function (message) {
//     // 如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员
//     console.log('onMutedMessage', message)
//   }
// })

WebIM.WebRTC = webrtc
WebIM.EMedia = emedia
export default WebIM
